module.exports = __webpack_public_path__ + "15eb0912d32bf8b3f32fdfac3e575060.svg";